import CoreLayout from './CoreLayout'
import enhance from './CoreLayout.enhancer.js'

export default enhance(CoreLayout)



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/index.js